import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";

import { StatisticsTab } from "./StatisticsTab.jsx";
import { ManualTab } from "./ManualTab/ManualTab";
import { Nullable } from "@hr/common/types";
import { PersonVacationBalanceJSON, EsalaryUserJSON } from "@hr/api/model";
import { ManualTabButtons } from "@hr/statisticsview/vacancy/ManualTab/components/ManualTabButtons.tsx";
import { ManualTabContextProvider } from "@hr/statisticsview/vacancy/ManualTab/ManualTabContext";
import { UpdateStatistics } from "./UpdateStatistics.js";
import { authSelector } from "../../reducers";

type TabsAvailable = "manual" | "statistics";

export function VacancyView() {
  const { t } = useTranslation();
  const auth: EsalaryUserJSON = useSelector(authSelector);
  
  const [activeTab, setActiveTab] = useState<Nullable<TabsAvailable>>("statistics"); // change to statistics in PR
  const manualTabGridRef = useRef<AgGridReact<PersonVacationBalanceJSON>>(null);

  return (
    <ManualTabContextProvider>
      <div className="d-flex justify-content-between" style={{ minHeight: "3.5rem" }}>
        <h2 className="viewheading">{t("AnnualVacationStatistics", "Vuosilomatilastot")}</h2>
        {activeTab === "manual" && <ManualTabButtons />}
        {activeTab === "statistics" && <UpdateStatistics />}
      </div>

      <Tabs
        onSelect={(tab) => setActiveTab(tab as TabsAvailable)}
        activeKey={activeTab as TabsAvailable}
        defaultActiveKey="apikey"
        className="mb-3"
      >
        <Tab eventKey="statistics" title={t("AnnualVacationStatistics", "Vuosilomatilastot")}>
          <StatisticsTab />
        </Tab>
        {auth.admin && (
          <Tab eventKey="manual" title={t("ManualSetUp","Määrittely")}>
            <ManualTab gridRef={manualTabGridRef} />
          </Tab>
        )}
      </Tabs>
    </ManualTabContextProvider>
  );
}
